import { render } from "./EmergencyMedicine.vue?vue&type=template&id=542741c6"
import script from "./EmergencyMedicine.vue?vue&type=script&lang=ts"
export * from "./EmergencyMedicine.vue?vue&type=script&lang=ts"
script.render = render

export default script